export const ROUTES = Object.freeze({
  LOGIN: "/login",
  LOGOUT: "/logout",

  RECOVERY: "/recovery",

  MARGIN: "/report-margin",
  MARGIN_ARCHIVE: "/report-margin-archive",
  MARGIN_PARTNER: "/report-margin-partner",
  MARGIN_PRODUCT: "/report-margin-product",
  REPORT_WALLETS_BALANCES: "/report-wallets-balances",
  REPORT_COMPANY_PROFIT: "/report-company-profit",
  REPORT_EMPLOYEES: "/report-employees",
  EFFICIENCY: "/report-efficiency",
  PRODUCTION_CALENDAR: "/production-calendar",
  UPDATE_DATA: "/update-data",

  SELLS: "/sells",
  USERS: "/users",
  CONTRACTS: "/contracts",
  SALARY: "/salary",
  PAYROLLS: "/payrolls",
  EXPENSES: "/expenses",
  TRANSFERS: "/transfers",
  TASKS: "/cabinet/tasks",
  USER_TASKS: "/user-tasks",
  PLANNED_EXPENSES: "/planned-expenses",
  UNALLOCATED_OPERATIONS: "/unallocated",
  CLIENTS: "/clients",
});
